import styled from 'styled-components';

import { fadeIn } from '@sorare/core/src/atoms/animations/keyframes';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { missionBackground } from '@sorare/core/src/components/missions/style';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

export const Root = styled(Vertical).attrs({ center: true, gap: 4 })`
  position: relative;
  height: 100%;
  width: 100%;
  padding: var(--double-unit);

  @media ${laptopAndAbove} {
    min-height: min(calc(90 * var(--unit)), 100vh);
  }

  &:not(.hideBackground) {
    ${missionBackground}
  }
`;

export const ButtonsWrapper = styled(Vertical)`
  position: absolute;
  bottom: var(--quadruple-unit);
  left: var(--double-unit);
  right: var(--double-unit);

  opacity: 0;
  animation: ${fadeIn} 0.65s cubic-bezier(0.75, 0.07, 0.23, 0.89) forwards;
  animation-delay: 1.35s;
`;
